import { EfsMelcoModelsDesign } from "melco-shared-logic";
import { useDesignSize } from "../../../hooks/libraries/designs/useDesignSize";

type DesignSizeProps = {
  design: EfsMelcoModelsDesign;
};

export const DesignSize: React.FC<DesignSizeProps> = ({ design }) => {
  const [isLoading, size] = useDesignSize(design);

  if (isLoading) {
    return null;
  }

  return <>{size}</>;
};
